import * as actions from '../actions';
import blueprints from './blueprints';
import discussions from './discussions';
import users from './users';
import groups from './groups';
import faqs from './faqs';
import {combineReducers} from 'redux';

export default combineReducers({
  blueprints,
  discussions,
  users,
  groups,
  faqs
});


// WEBPACK FOOTER //
// ./src/store/reducers/index.js